import iconPath from '@/assets/device-icons/macbook-pro-2020.svg';

interface MacbookPro2020IconProps {
  className?: string;
}

export const MacbookPro2020Icon = ({ className = "h-5 w-5" }: MacbookPro2020IconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="MacBook Pro 2020" 
      className={className}
    />
  );
};
